import React from "react";
import { useCurrentUser } from "../../../../hooks/currentUser";

export default () => {
  const { currentUser } = useCurrentUser();
  return (
    <>
      <div>The Vestillion Home Page</div>
      <div>
        Welcome, {currentUser?.givenName} {currentUser?.familyName}
      </div>
    </>
  );
};
